import uuid from "uuid/v1";
import PriorityProcessingImage from "./PriorityProcessings.base6";
import {
  giftImg,
  fastShippingImg,
  warranteeImg,
  fastProcessingImg
} from "assets/products";
import Languages from "./translations";
// import compareVersions from 'compare-versions';

export const BREAK_POINTS = {
  kill_draft: (shopContext) => {
    return shopContext.state.settings.multiCurrencyMode;
    // const installedAt = new Date(shopContext.state.installedAt).getTime();
    // const breakPoint = new Date('Sun Apr 18 2021 15:00:00 GMT+0100').getTime();
    // return installedAt > breakPoint;
  }
};

export const CAMPAIGN_TARGETS = [
  { value: "all_products", label: "All Products", },
  { value: "specific_products", label: "Specific Products" },
  { value: "specific_collections", label: "Specific Collections" }
];


export const ADD_TO_UNLOCK_FREE_SHIPPING_HANDLER = [
  {
    value: false,
    label: "MonsterUpsells",
    info: "Shopify will inject a unique Free Shipping coupon code at checkout"
  },
  {
    value: true,
    label: "Shopify Admin",
    info: "You need to setup Free Shipping threshold in Shopify Admin",
    link: {
      href: "https://help.shopify.com/en/manual/shipping/setting-up-and-managing-your-shipping/setting-up-shipping-rates?fbclid=IwAR3OtBxohPJS0X1kzl1sOLfIqyCHkJkiLGiJPwmeAlkK3MAfZN6VdtmQw2s#create-free-shipping-rates",
      text: "Learn More"
    }
  }
];
export const CAMPAIGN_TYPES = {
  bundles: "buy more save more",
  add_to_unlock: "Add to unlock + Frequently bought Together",
  one_check_up_sell: "one tick upsell"
};

export const ONE_CHECK_UP_SELL_PRODUCT_TYPE_OPTIONS = [
  { value: "hidden", label: "Virtual Product" },
  { value: "existing", label: "Existing Product" }
];

export const GOOGLE_FONTS = [
  { value: "Raleway", label: "Raleway" },
  { value: "Dosis", label: "Dosis" }
];

export const RESOURCE_PICKER_DEFAULT_REDUCERS = {
  Product: ({ id, title, variants, images, handle, descriptionHtml, options,...rest }) => ({
    id,
    title,
    handle,
    images: images.map(({originalSrc, id}) => {return {id, src: originalSrc}}),
    image: images.length ? images[0].originalSrc : null,
    price: variants[0].price,  
    description: '{productDescription}',
    originalDescription: descriptionHtml,
    variants: variants.map(ADD_TO_UNLOCK_PRODUCTS_VARIANTS_MAP),
    options,
    // rest
  }),
  Collection: ({ id, title, image, handle }) => ({
    id,
    title,
    handle,
    image: image && image.originalSrc ? image.originalSrc : null
  })
};

export const ADD_TO_UNLOCK_PRODUCTS_PICKER_REDUCER = ({
  id,
  title,
  variants,
  options,
  images,
  handle
}) => ({
  id,
  title,
  handle,
  image: images.length ? images[0].originalSrc : null,
  variants: variants.map(ADD_TO_UNLOCK_PRODUCTS_VARIANTS_MAP),
  options
});

export const ONE_CHECK_UP_SELL_PRODUCT_REDUCER = ({
  id,
  title,
  variants,
  options,
  images,
  image,
  handle,
  body_html
}) => ({
  id: id.toString(),
  title: title.toString(),
  handle,
  image: image ? image.originalSrc : images[0].src || images[0].originalSrc,
  variant_id: variants[0].id.toString(),
  options,
  variants: variants.map(ADD_TO_UNLOCK_PRODUCTS_VARIANTS_MAP)
});

export const GIFT_WITH_PURCHASE_PRODUCT_REDUCER = (product) => {
  const { id, title, variants, options, images, image, handle, body_html } = product
  const variant = variants[0]
  if (!variant) throw new Error("variant not found")
  const price = Number(variant.price) * 100
  const compareAtPrice = variant.compareAtPrice ? Number(variant.compareAtPrice) * 100 : price
  return ({
    id: id.toString(),
    title: title.toString(),
    image: image ? image.originalSrc : images[0].src || images[0].originalSrc,
    variant_id: variant.id.toString(),
    variant_price: compareAtPrice
  })
};

const ADD_TO_UNLOCK_PRODUCTS_VARIANTS_MAP = ({ id, title, price, image }) => ({
  id: id.toString(),
  title,
  price,
  image: image ? image.originalSrc : null
});

export const DISCOUNT_TYPES = (currency = "$ ") => [
  { label: "% ", value: "percentage" },
  { label: `${currency} `, value: "fixed_amount" }
];

export const GET_GOAL_TYPES = (currency = "$ ") => {
  return [
    { label: "% ", value: "relative" },
    { label: `${currency} `, value: "fixed" }
  ];
};
export const PRODUC_TYPE_SELECT_OPTIONS = () => {
  return [
    {
      value: "specific_product",
      label: "Specific product",
      info: "Unlock discounts that will be auto aded to the checkout using discount codes"
    },
    {
      value: "auto_upsell",
      label: "Auto Upsell",
      info: "Shopify machine learning will choose product using purchase history",
    },
    {
      value: "most_expensive",
      label: "Most expensive product in order",
      info: "Most expensive product in order will be offered with a discount",
    },
    {
      value: "most_cheapest",
      label: "Cheapest product in order",
      info: "Cheapest product in order will be offered with a discount"
    },
  ];
};

export const FUNNEL_TYPE_SELECT_OPTIONS =  [
    {
      value: "auto_funnel",
      label: "Monster machine",
      info: "Start with our most quick setup funnel"
    },
    {
      value: "manual_funnel",
      label: "Start from scratch",
      info: "Use our step by step funnel builder",
    },
  ];

export const ADD_TO_UNLOCK_REWARD_OPTIONS = (goals, index) => {
  const otherGoals = goals
    .filter((_, i) => i !== index)
    .map(({ reward_type }) => reward_type);
  return [
    {
      value: "discount",
      label: "Discount",
      info: "Unlock discounts that will be auto aded to the checkout using discount codes"
    },
    {
      value: "free_shipping",
      label: "Free Shipping",
      info: "You need to setup free shipping options in Shopify Admin",
      disabled: otherGoals.includes("free_shipping")
    },
    {
      value: "gift",
      label: "Free Gift",
      info: "Select a product as a free gift when cart goals are met",
      disabled: !goals[index].gift,
      beta: true
    },
    {
      value: "manual",
      label: "Manual",
      infoHtml: true,
      info: "Create a goal that you will reward yourself.<br/><b>Example:</b> Free products, Gift wrapping, Free express shipping"
    },
  ];
};

export const CART_SLIDER_SETTINGS = {
  dots: false,
  arrows: false,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  adaptiveHeight: false,
  draggable: false,
  infinite: false,
  easing: "easeOut"
};

export const defaultOffer = (customeSettings = {}) =>  {
  return {  
    productType: null,
    product: { },
    blocks: {
      "banner": {
        "background_color": "warning",
        "description": "<p>Add <strong>{productTitle}</strong> to your order and save <strong>{discount}%</strong></p>",
        "description_quill": "{\"ops\":[{\"insert\":\"Add \"},{\"attributes\":{\"bold\":true},\"insert\":\"{productTitle}\"},{\"insert\":\" to your order and save \"},{\"attributes\":{\"bold\":true},\"insert\":\"{discount}%\"},{\"insert\":\"\\n\"}]}",
        "heading": "<p>Limited time offer <strong>{timer}</strong></p>",
        "heading_quill": "{\"ops\":[{\"insert\":\"Limited time offer \"},{\"attributes\":{\"bold\":true},\"insert\":\"{timer}\"},{\"insert\":\"\\n\"}]}",
        "isActive": true,
        "timer_end_action": "skip",
        "timer_value": 10
      },
      "checkout_button": {
        "isActive": false,
        "showTotal": true
      },
      "extra_blocks": [
        {

          "alignement": "right",
          "description": "<p>Add a detailed description of your unique key benifits and features.</p>",
          "description_quill": "{\"ops\":[{\"insert\":\"Add a detailed description of your unique key benifits and features.\\n\"}]}",
          "header": "<p><strong class=\"ql-size-large\" style=\"color: rgb(88, 88, 88);\">Call out header</strong></p>",
          "header_quill": "{\"ops\":[{\"attributes\":{\"color\":\"#585858\",\"size\":\"large\",\"bold\":true},\"insert\":\"Call out header\"},{\"insert\":\"\\n\"}]}",
          "isActive": false,
          "withImage": true
        },
        {
          "alignement": "left",
          "description": "<p>Add a detailed description of your unique key benifits and features.</p>",
          "description_quill": "{\"ops\":[{\"insert\":\"Add a detailed description of your unique key benifits and features.\\n\"}]}",
          "header": "<p><strong class=\"ql-size-large\" style=\"color: rgb(88, 88, 88);\">Call out header</strong></p>",
          "header_quill": "{\"ops\":[{\"attributes\":{\"color\":\"#585858\",\"size\":\"large\",\"bold\":true},\"insert\":\"Call out header\"},{\"insert\":\"\\n\"}]}",
          "isActive": false,
          "withImage": true
        }
      ],
      "product_config": {
        "extra_text": "<p class=\"ql-align-center\"><strong style=\"color: rgb(88, 88, 88);\">100% Money back guarantee</strong></p>",
        "extra_text_quill": "{\"ops\":[{\"attributes\":{\"color\":\"#585858\",\"bold\":true},\"insert\":\"100% Money back guarantee\"},{\"attributes\":{\"align\":\"center\"},\"insert\":\"\\n\"}]}",
        "image_border": true,
        "price": "<p><s class=\"ql-size-large\" style=\"color: rgb(88, 88, 88);\">{originalPrice}</s><span class=\"ql-size-large\" style=\"color: rgb(88, 88, 88);\"> </span><strong class=\"ql-size-large\" style=\"color: rgb(88, 88, 88);\">{discountedPrice}</strong><strong class=\"ql-size-large\"> </strong><span class=\"ql-size-large\" style=\"color: rgb(12, 161, 39);\">(</span><strong class=\"ql-size-large\" style=\"color: rgb(12, 161, 39);\">Saving {discount}%)</strong></p>",
        "price_quill": "{\"ops\":[{\"attributes\":{\"color\":\"#585858\",\"size\":\"large\",\"strike\":true},\"insert\":\"{originalPrice}\"},{\"attributes\":{\"size\":\"large\",\"color\":\"#585858\"},\"insert\":\" \"},{\"attributes\":{\"size\":\"large\",\"color\":\"#585858\",\"bold\":true},\"insert\":\"{discountedPrice}\"},{\"attributes\":{\"size\":\"large\",\"bold\":true},\"insert\":\" \"},{\"attributes\":{\"size\":\"large\",\"color\":\"#0ca127\"},\"insert\":\"(\"},{\"attributes\":{\"size\":\"large\",\"color\":\"#0ca127\",\"bold\":true},\"insert\":\"Saving {discount}%)\"},{\"insert\":\"\\n\"}]}",
        "show_quantity": true,
        "show_variants": true,
        "show_saving": true,
        "show_shipping": true,
        "show_taxes": true,
        "header": "<p><span class=\"ql-size-huge\" style=\"color: rgb(88, 88, 88);\">{productTitle}</span></p>",
        "header_quill": "{\"ops\":[{\"attributes\":{\"color\":\"#585858\",\"size\":\"huge\"},\"insert\":\"{productTitle}\"},{\"insert\":\"\\n\"}]}",
      }
    },
    discount_type: "percentage",
    discount_value: 20,
    ...customeSettings
  }
}

export const NEW_CAMPAIGN_INITIAL_STATE = ( ) => {
  return {
    settings: {

    },
    // target: {
    //   type: "all_products",
    //   ids: [],
    //   selected: [],
    //   countries: {
    //     include_active: false,
    //     include: ["worldwide"],
    //     exclude_active: false,
    //     exclude: []
    //   }
    // }
  };
};

export const default_one_check_upsell = language => {
  return {
    text: Languages[language].campaigns.one_check_up_sell.text,
    is_ticked_by_default: false,
    include_in_atu: true,
    product: {},
    product_type: "existing",
    truncate: true,
    truncate_length: 25
  }
}


export const DEFAULT_ICONS = [
  {
    id:1,
    prefix: "fas",
    iconName: "shield-halved",
    icon: [
      512,
      512,
      [],
      "f81d",
      "M256 0c4.6 0 9.2 1 13.4 2.9L457.7 82.8c22 9.3 38.4 31 38.3 57.2c-.5 99.2-41.3 280.7-213.6 363.2c-16.7 8-36.1 8-52.8 0C57.3 420.7 16.5 239.2 16 140c-.1-26.2 16.3-47.9 38.3-57.2L242.7 2.9C246.8 1 251.4 0 256 0zm0 66.8V444.8C394 378 431.1 230.1 432 141.4L256 66.8l0 0z",
    ]
  },
  {
    id:2,
    prefix: "fas",
    iconName: "umbrella",
    icon: [
      576,
      512,
      [],
      "f505",
      "M288 0c17.7 0 32 14.3 32 32V49.7C451.8 63.4 557.7 161 573.9 285.9c2 15.6-17.3 24.4-27.8 12.7C532.1 283 504.8 272 480 272c-38.7 0-71 27.5-78.4 64.1c-1.7 8.7-8.7 15.9-17.6 15.9s-15.8-7.2-17.6-15.9C359 299.5 326.7 272 288 272s-71 27.5-78.4 64.1c-1.7 8.7-8.7 15.9-17.6 15.9s-15.8-7.2-17.6-15.9C167 299.5 134.7 272 96 272c-24.8 0-52.1 11-66.1 26.7C19.4 310.4 .1 301.5 2.1 285.9C18.3 161 124.2 63.4 256 49.7V32c0-17.7 14.3-32 32-32zm0 304c12.3 0 23.5 4.6 32 12.2V430.6c0 45-36.5 81.4-81.4 81.4c-30.8 0-59-17.4-72.8-45l-2.3-4.7c-7.9-15.8-1.5-35 14.3-42.9s35-1.5 42.9 14.3l2.3 4.7c3 5.9 9 9.6 15.6 9.6c9.6 0 17.4-7.8 17.4-17.4V316.2c8.5-7.6 19.7-12.2 32-12.2z"
    ]
  },
  {
    id:3,
    prefix: "fas",
    iconName: "shield",
    icon: [
      512,
      512,
      [],
      "f505",
      "M256 0c4.6 0 9.2 1 13.4 2.9L457.7 82.8c22 9.3 38.4 31 38.3 57.2c-.5 99.2-41.3 280.7-213.6 363.2c-16.7 8-36.1 8-52.8 0C57.3 420.7 16.5 239.2 16 140c-.1-26.2 16.3-47.9 38.3-57.2L242.7 2.9C246.8 1 251.4 0 256 0z"
    ]
  }
]

export const SHOP_DEFAULT_SETTINGS = (language) => {
  return {
    active: false,
    productId: null,
    icon:{
      image: "https://monsterocu-prod-publicfiles.s3.eu-central-1.amazonaws.com/shipprotect-main.png",
      isExternal: false,
    },
    title: {
      text: "Shipping Protection",
      font_size: 14,
      color: { r: 82, g: 82, b: 82, a: 1 }
    },
    subtitle: {
      text: "From damage, Loss and Theft from {{price}}",
      font_size: 12,
      color: { r: 139, g: 139, b: 139, a: 1 }
    },
    selectedMessage: {
      text: "By deselecting shipping protection, we are not liable for lost, damaged, or stolen items.",
      font_size: 12,
      color: { r: 139, g: 139, b: 139, a: 1 }
    },
    unselectedMessage: {
      text: "Cover packages that are lost, damaged, or stolen during transit.",
      font_size: 12,
      color: { r: 139, g: 139, b: 139, a: 1 }
    },
    pricing: {
      type: "percentage",
      value: 2,

    }, 
    checker_type: "ticker",
    checker_position: "right",
    offer_position: "above",
    pre_select: true, 
    product_description: {
      text: "If your product is lost, stolen or damaged. Reach out to the team within 30 days and we will refund.",
      font_size: 10,
      color:  { r: 255, g: 255, b: 255, a: 1 }
    },
    tooltip: {
      active: false,
      withLink: true,
      linkText: {
        text: "Learn more",
        font_size: 10,
        color: { r: 255, g: 255, b: 255, a: 1 }
      },
      link: "https://google.com",
      background: { r: 0, g: 0, b: 0, a: 1 },
      symbol: { r: 0, g: 0, b: 0, a: 1 },
    },
    priceStep: 1,
    priceMin: 1,
    smartprotect: true,
  }
};


export const BADGE_PERCENT_ICON = {
  //this icon is missing on fontawesome package
  prefix: "fas",
  iconName: "adjust",
  icon: [
    512,
    512,
    [],
    "f646",
    "M512 256c0-37.7-23.7-69.9-57.1-82.4 14.7-32.4 8.8-71.9-17.9-98.6-26.7-26.7-66.2-32.6-98.6-17.9C325.9 23.7 293.7 0 256 0s-69.9 23.7-82.4 57.1c-32.4-14.7-72-8.8-98.6 17.9-26.7 26.7-32.6 66.2-17.9 98.6C23.7 186.1 0 218.3 0 256s23.7 69.9 57.1 82.4c-14.7 32.4-8.8 72 17.9 98.6 26.6 26.6 66.1 32.7 98.6 17.9 12.5 33.3 44.7 57.1 82.4 57.1s69.9-23.7 82.4-57.1c32.6 14.8 72 8.7 98.6-17.9 26.7-26.7 32.6-66.2 17.9-98.6 33.4-12.5 57.1-44.7 57.1-82.4zm-320-96c17.67 0 32 14.33 32 32s-14.33 32-32 32-32-14.33-32-32 14.33-32 32-32zm12.28 181.65c-6.25 6.25-16.38 6.25-22.63 0l-11.31-11.31c-6.25-6.25-6.25-16.38 0-22.63l137.37-137.37c6.25-6.25 16.38-6.25 22.63 0l11.31 11.31c6.25 6.25 6.25 16.38 0 22.63L204.28 341.65zM320 352c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
  ]
};

const parseProductId = (string) => {
  // example gid://shopify/ProductVariant/19566771404862
  const pattern = new RegExp("gid://shopify/Product/([0-9]+)$");
  if (pattern.test(string)) return parseInt(string.match(pattern)[1]);
  return string;
};

export const stateCards = [
  { title: "ProtectionRevenue", label: "Revenue", currency: true },
  { title: "AcceptedOffers", label: "Offers Accepted" },
  { title: "Conversion", suf: "%", clickable: false },
  { title: "TotalROI", suf: "%", clickable: false }
];

export const ProductStats = [
  { title: "impressions", label: "Impressions", currency: false },
  { title: "conversion", label: "Conversion", suf: "%" },
  { title: "total", label: "Total", currency: true },
  { title: "average", label: "Average", currency: true },

]

export const chartOptions = (formatter) => ({
  fill: {
    type: "solid",
    color: "#485aff",
    opacity: 0.15
  },
  width: "50%",
  stroke: {
    show: true,
    curve: "smooth",
    lineCap: "butt",
    colors: ["#2F80ED"],
    width: 4,
    dashArray: 0
  },
  dropShadow: {
    enabled: true,
    top: 1,
    left: 1,
    blur: 2,
    color: "#000",
    opacity: 0.9
  },
  xaxis: {
    type: "datetime"
  },
  yaxis: {
    type: "numeric"
  },
  dataLabels: {
    enabled: false,
    enabledOnSeries: undefined,
    formatter
  }
});

export const ENGINE_WARNING_ICON = {
  prefix: "fas",
  iconName: "engine-warning",
  icon: [
    640,
    448,
    [],
    "f5f2",
    "M48 256c0-59.53 19.55-117.38 55.36-164.51 5.18-6.81 4.48-16.31-2.03-21.86l-12.2-10.41c-6.91-5.9-17.62-5.06-23.15 2.15C23.32 117.02 0 185.5 0 256c0 70.47 23.32 138.96 65.96 194.62 5.53 7.21 16.23 8.05 23.15 2.16l12.19-10.4c6.51-5.55 7.21-15.04 2.04-21.86C67.55 373.37 48 315.53 48 256zM320 32C196.3 32 96 132.3 96 256c0 123.76 100.3 224 224 224s224-100.24 224-224c0-123.7-100.3-224-224-224zm0 352c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm25.44-110.41c-.82 8.18-7.7 14.41-15.92 14.41h-19.04c-8.22 0-15.1-6.23-15.92-14.41l-12.8-128c-.94-9.42 6.45-17.59 15.92-17.59h44.64c9.47 0 16.86 8.17 15.92 17.59l-12.8 128zM572.73 59.71c-5.58-7.18-16.29-7.95-23.17-2l-12.15 10.51c-6.47 5.6-7.1 15.09-1.88 21.87C572.04 137.47 592 195.81 592 256c0 60.23-19.96 118.57-56.46 165.95-5.22 6.78-4.59 16.27 1.88 21.87l12.15 10.5c6.87 5.95 17.59 5.18 23.17-2C616.21 396.38 640 327.31 640 256c0-71.27-23.79-140.34-67.27-196.29z"
  ]
};
export const SACK_DOLLAR_ICON = {
  prefix: "fas",
  iconName: "sack-dollar",
  icon: [
    512,
    512,
    [],
    "f81d",
    "M192 96h128l47.4-71.12A16 16 0 0 0 354.09 0H157.94a16 16 0 0 0-13.31 24.88zm128 32H192C-10.38 243.4.09 396.64.09 416c0 53 49.11 96 109.68 96h292.48c60.58 0 109.68-43 109.68-96 0-19 9.35-173.24-191.93-288zm-46.58 278v17.34a8.68 8.68 0 0 1-8.7 8.62h-17.41a8.69 8.69 0 0 1-8.71-8.62v-17.51a63.14 63.14 0 0 1-34.16-12.17 8.52 8.52 0 0 1-.67-13l12.84-12.06a8.93 8.93 0 0 1 11-.76 26.71 26.71 0 0 0 13.93 4h30.58c7.07 0 12.84-6.35 12.84-14.22 0-6.46-3.92-12.06-9.58-13.67l-49-14.54c-20.24-6-34.39-25.2-34.39-46.74 0-26.38 20.68-47.82 46.46-48.57v-17.48a8.69 8.69 0 0 1 8.75-8.62h17.41a8.68 8.68 0 0 1 8.7 8.62v17.55a63.15 63.15 0 0 1 34.17 12.17 8.54 8.54 0 0 1 1.58 12 8.72 8.72 0 0 1-.92 1l-12.73 12.2a8.91 8.91 0 0 1-11 .75 26.8 26.8 0 0 0-13.93-4h-30.57c-7.07 0-12.84 6.35-12.84 14.21 0 6.46 3.92 12.06 9.57 13.68l49 14.54c20.24 6 34.38 25.2 34.38 46.74-.14 26.4-20.92 47.94-46.6 48.54z"
  ]
};

export const TestIcon = {
  prefix: "fas",
  iconName: "flask-vial",
  icon: [
    640,
    512,
    [],
    "f81d",
    "M175 389.4c-9.8 16-15 34.3-15 53.1c-10 3.5-20.8 5.5-32 5.5c-53 0-96-43-96-96V64C14.3 64 0 49.7 0 32S14.3 0 32 0H96h64 64c17.7 0 32 14.3 32 32s-14.3 32-32 32V309.9l-49 79.6zM96 64v96h64V64H96zM352 0H480h32c17.7 0 32 14.3 32 32s-14.3 32-32 32V214.9L629.7 406.2c6.7 10.9 10.3 23.5 10.3 36.4c0 38.3-31.1 69.4-69.4 69.4H261.4c-38.3 0-69.4-31.1-69.4-69.4c0-12.8 3.6-25.4 10.3-36.4L320 214.9V64c-17.7 0-32-14.3-32-32s14.3-32 32-32h32zm32 64V224c0 5.9-1.6 11.7-4.7 16.8L330.5 320h171l-48.8-79.2c-3.1-5-4.7-10.8-4.7-16.8V64H384z"
  ]
}

export const refreshIcon = {
  prefix: "fas",
  iconName: "arrows-rotate",
  icon: [
    512,
    512,
    [],
    "f81d",
    "M89.1 202.6c7.7-21.8 20.2-42.3 37.8-59.8c62.5-62.5 163.8-62.5 226.3 0L370.3 160H320c-17.7 0-32 14.3-32 32s14.3 32 32 32H447.5c0 0 0 0 0 0h.4c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v51.2L398.4 97.6c-87.5-87.5-229.3-87.5-316.8 0C57.2 122 39.6 150.7 28.8 181.4c-5.9 16.7 2.9 34.9 19.5 40.8s34.9-2.9 40.8-19.5zM23 289.3c-5 1.5-9.8 4.2-13.7 8.2c-4 4-6.7 8.8-8.1 14c-.3 1.2-.6 2.5-.8 3.8c-.3 1.7-.4 3.4-.4 5.1V448c0 17.7 14.3 32 32 32s32-14.3 32-32V396.9l17.6 17.5 0 0c87.5 87.4 229.3 87.4 316.7 0c24.4-24.4 42.1-53.1 52.9-83.7c5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8c-62.5 62.5-163.8 62.5-226.3 0l-.1-.1L109.6 352H160c17.7 0 32-14.3 32-32s-14.3-32-32-32H32.4c-1.6 0-3.2 .1-4.8 .3s-3.1 .5-4.6 1z"
  ]
}

export const COMMENT_DOLLAR = {
  prefix: "fas",
  iconName: "comment-dollar",
  icon: [
    512,
    512,
    [],
    "f81d",
    "M256 32C114.62 32 0 125.12 0 240c0 49.56 21.41 95.01 57.02 130.74C44.46 421.05 2.7 465.97 2.2 466.5A7.995 7.995 0 0 0 8 480c66.26 0 115.99-31.75 140.6-51.38C181.29 440.93 217.59 448 256 448c141.38 0 256-93.12 256-208S397.38 32 256 32zm24 302.44V352c0 8.84-7.16 16-16 16h-16c-8.84 0-16-7.16-16-16v-17.73c-11.42-1.35-22.28-5.19-31.78-11.46-6.22-4.11-6.82-13.11-1.55-18.38l17.52-17.52c3.74-3.74 9.31-4.24 14.11-2.03 3.18 1.46 6.66 2.22 10.26 2.22h32.78c4.66 0 8.44-3.78 8.44-8.42 0-3.75-2.52-7.08-6.12-8.11l-50.07-14.3c-22.25-6.35-40.01-24.71-42.91-47.67-4.05-32.07 19.03-59.43 49.32-63.05V128c0-8.84 7.16-16 16-16h16c8.84 0 16 7.16 16 16v17.73c11.42 1.35 22.28 5.19 31.78 11.46 6.22 4.11 6.82 13.11 1.55 18.38l-17.52 17.52c-3.74 3.74-9.31 4.24-14.11 2.03a24.516 24.516 0 0 0-10.26-2.22h-32.78c-4.66 0-8.44 3.78-8.44 8.42 0 3.75 2.52 7.08 6.12 8.11l50.07 14.3c22.25 6.36 40.01 24.71 42.91 47.67 4.05 32.06-19.03 59.42-49.32 63.04z"
  ]
};
export const BOX_CHECK_ICON = {
  prefix: "fas",
  iconName: "box-check",
  icon: [
    640,
    512,
    [],
    "f467",
    "M240 0H98.6c-20.7 0-39 13.2-45.5 32.8L2.5 184.6c-.8 2.4-.8 4.9-1.2 7.4H240V0zm235.2 81.7l-16.3-48.8C452.4 13.2 434.1 0 413.4 0H272v157.4C315.9 109.9 378.4 80 448 80c9.2 0 18.3.6 27.2 1.7zM208 320c0-34.1 7.3-66.6 20.2-96H0v240c0 26.5 21.5 48 48 48h256.6C246.1 468.2 208 398.6 208 320zm240-192c-106 0-192 86-192 192s86 192 192 192 192-86 192-192-86-192-192-192zm114.1 147.8l-131 130c-4.3 4.3-11.3 4.3-15.6-.1l-75.7-76.3c-4.3-4.3-4.2-11.3.1-15.6l26-25.8c4.3-4.3 11.3-4.2 15.6.1l42.1 42.5 97.2-96.4c4.3-4.3 11.3-4.2 15.6.1l25.8 26c4.2 4.3 4.2 11.3-.1 15.5z"
  ]
};
export const PERCENTAGE_ICON = {
  prefix: "fas",
  iconName: "percentage",
  icon: [
    384,
    512,
    [],
    "f541",
    "M109.25 173.25c24.99-24.99 24.99-65.52 0-90.51-24.99-24.99-65.52-24.99-90.51 0-24.99 24.99-24.99 65.52 0 90.51 25 25 65.52 25 90.51 0zm256 165.49c-24.99-24.99-65.52-24.99-90.51 0-24.99 24.99-24.99 65.52 0 90.51 24.99 24.99 65.52 24.99 90.51 0 25-24.99 25-65.51 0-90.51zm-1.94-231.43l-22.62-22.62c-12.5-12.5-32.76-12.5-45.25 0L20.69 359.44c-12.5 12.5-12.5 32.76 0 45.25l22.62 22.62c12.5 12.5 32.76 12.5 45.25 0l274.75-274.75c12.5-12.49 12.5-32.75 0-45.25z"
  ]
};

export const COMMENT_ALT_SMILE_ICON = {
  prefix: "fas",
  iconName: "comment-alt-smile",
  icon: [
    512,
    512,
    [],
    "f4aa",
    "M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 9.8 11.2 15.5 19.1 9.7L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zM320 133.2c14.8 0 26.8 12 26.8 26.8s-12 26.8-26.8 26.8-26.8-12-26.8-26.8 12-26.8 26.8-26.8zm-128 0c14.8 0 26.8 12 26.8 26.8s-12 26.8-26.8 26.8-26.8-12-26.8-26.8 12-26.8 26.8-26.8zm164.2 140.9C331.3 303.3 294.8 320 256 320c-38.8 0-75.3-16.7-100.2-45.9-5.8-6.7-5-16.8 1.8-22.5 6.7-5.7 16.8-5 22.5 1.8 18.8 22 46.5 34.6 75.8 34.6 29.4 0 57-12.6 75.8-34.7 5.8-6.7 15.9-7.5 22.6-1.8 6.8 5.8 7.6 15.9 1.9 22.6z"
  ]
};

export const USER_SHIELD_ICON = {
  prefix: "fas",
  iconName: "user-shield",
  icon: [
    640,
    512,
    [],
    "f505",
    "M622.3 271.1l-115.2-45c-4.1-1.6-12.6-3.7-22.2 0l-115.2 45c-10.7 4.2-17.7 14-17.7 24.9 0 111.6 68.7 188.8 132.9 213.9 9.6 3.7 18 1.6 22.2 0C558.4 489.9 640 420.5 640 296c0-10.9-7-20.7-17.7-24.9zM496 462.4V273.3l95.5 37.3c-5.6 87.1-60.9 135.4-95.5 151.8zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm96 40c0-2.5.8-4.8 1.1-7.2-2.5-.1-4.9-.8-7.5-.8h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c6.8 0 13.3-1.5 19.2-4-54-42.9-99.2-116.7-99.2-212z"
  ]
};

export const PRESET_HIDDEN_PRODUCTS = [
  {
    id: 1,
    title: "Gift Wrappping",
    price: 2.55,
    body_html:
      "<p>Buying&nbsp;a&nbsp;Gift?&nbsp;Let&nbsp;us&nbsp;wrap&nbsp;it&nbsp;for&nbsp;you!</p><p>One of our team, will carefully wrap all you items individually to make your (someone special)...feel special!</p>",
    image: giftImg
  },
  {
    id: 4,
    title: "Fast Processing",
    price: 2.55,
    body_html:
      "<p>Want to get your order FAST?</p><p>Get Priority Processing and we'll bump your order up to the front of the line.&nbsp;</p>",
    image: fastProcessingImg
  },
  {
    id: 2,
    title: "Extended waranty",
    price: 4.19,
    body_html: "<p>We will cover any manufacturing faults for 2 years!</p>",
    image: warranteeImg
  }
];
export const TEST_COOKIE_NAME = "shopifyTestCookie";
export const GRANTED_STORAGE_ACCESS_COOKIE_NAME =
  "shopify.granted_storage_access";

export const DEFAULT_GOAL = ({ multi_goal_type, goals }, language) => {
  language = Object.keys(Languages).includes(language) ? language : "english";
  const index = goals.length;
  const goal = multi_goal_type === "amount" ? 40 + 20 * index : 2 + 2 * index;
  const reward = 10 + 5 * index;
  return {
    goal,
    reward_type: "discount", // free_shipping,discount
    goal_type: "fixed",
    goal_text: {
      text: reward + "% OFF",
      font_size: 0.7,
      color: {
        r: 44,
        g: 50,
        b: 59,
        a: 1
      }
    },
    show_goal_text: true,
    confetti: false,
    confetti_length: 400,
    discount: {
      type: "percentage",
      before: Languages[language].campaigns.add_to_unlock.discount.before,
      after: Languages[language].campaigns.add_to_unlock.discount.after,
      reward
    },
    free_shipping: {
      before: Languages[language].campaigns.add_to_unlock.free_shipping.before,
      after: Languages[language].campaigns.add_to_unlock.free_shipping.after,
      manual: true
    },
    manual: {
      before: Languages[language].campaigns.add_to_unlock.free_shipping.before,
      after: Languages[language].campaigns.add_to_unlock.free_shipping.after
    },
    gift: {
      before:
        Languages[language].campaigns.add_to_unlock.gift
          .before,
      after:
        Languages[language].campaigns.add_to_unlock.gift.after,
      product: {},
      widget: {
        active: true,
        compare_at_price_active: true,
        compare_at_price: {
          color: { r: 141, g: 141, b: 141, a: 1 },
          font_size: 1,
          text: Languages[language].campaigns.add_to_unlock.gift.compare_at_price.text
        },
        before: {
          header: Languages[language].campaigns.add_to_unlock.gift.widget.before.header,
          product_name: Languages[language].campaigns.add_to_unlock.gift.widget.before.product_name,
          offer_highlight: {
            color: { r: 47, g: 128, b: 237, a: 1 },
            font_size: 1.2,
            text: Languages[language].campaigns.add_to_unlock.gift.widget.before.offer_highlight.text
          },
          background: { r: 242, g: 245, b: 255, a: 1 },
          outline: { r: 196, g: 196, b: 196, a: 1 }
        },
        after: {
          header: Languages[language].campaigns.add_to_unlock.gift.widget.after.header,
          product_name: Languages[language].campaigns.add_to_unlock.gift.widget.after.product_name,
          offer_highlight: {
            color: { r: 79, g: 181, b: 110, a: 1 },
            font_size: 1.2,
            text: Languages[language].campaigns.add_to_unlock.gift.widget.after.offer_highlight.text
          },
          background: { r: 248, g: 251, b: 246, a: 1 },
          outline: { r: 203, g: 235, b: 206, a: 1 }
        },
      }
    }
  };
};
export const COD_FORM = [];

export const STICKY_CART_OPTIONS = {
  btnStyles: [
    { value: "square", label: "Square" },
    { value: "curvy", label: "Curvy" }
    // { value: 'organic', label: 'Organic' },
  ],
  btnPosition: [
    { value: "bottom", label: "Bottom" },
    { value: "top", label: "Top" }
  ],
  visibilityOptions: [
    { value: "always", label: "Always" },
    { value: "dynamic", label: 'when "Add To Cart" is hidden' }
  ],
  atcActions: [
    { value: "checkout", label: "Redirect to checkout page" },
    { value: "cart", label: "Redirect to cart" },
    { value: "stay", label: "Stay in product page" }
  ]
};


export const POS_COLORS = [
  { value: "gray", label: "Gray" },
  { value: "info", label: "Blue" },
  { value: "warning", label: "Yellow" },
  { value: "critical", label: "Red" },
  { value: "success", label: "Green" },
]

export const POS_FONT_SIZE = [
  { value: "9", label: "9" },
  { value: "12", label: "12" },
  { value: "14", label: "14" },
  { value: "16", label: "16" },
  { value: "18", label: "18" },
  { value: "24", label: "24" },
]


export const PRODUCT_AUTO_SELECT =  {
  "id": "77700046043",
  "originalDescription": "<p>Lorem Ipsumis simply dummy text. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>",
  "description": "{productDescription}",
  "description_quill": "{\"ops\":[{\"insert\":\"{productDescription}\\n\"}]}",
  "handle": "auto-upsell",
  "image": "https://boltagency.ca/content/images/2020/03/placeholder-images-product-1_large.png",
  "images": [
   {
    "id": "37771328028923",
    "src": "https://boltagency.ca/content/images/2020/03/placeholder-images-product-1_large.png"
   }
  ],
  "options": [
   {
    "id": "9987733979387",
    "name": "Title",
    "position": 1,
    "values": [
     "Default Title"
    ]
   }
  ],
  "price": "12.99",
  "title": "Auto upsell",
  "variants": [
   {
    "id": "43276074680571",
    "price": "12.99",
    "title": "Default Title"
   }
  ]
 }

 
export const PRODUCT_EXPENSIVE_SELECT =  {
  "id": "7006946043",
  "originalDescription": "<p>Lorem Ipsumis simply dummy text. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>",
  "description": "{productDescription}",
  "description_quill": "{\"ops\":[{\"insert\":\"{productDescription}\\n\"}]}",
  "handle": "most-expensive",
  "image": "https://boltagency.ca/content/images/2020/03/placeholder-images-product-1_large.png",
  "images": [
   {
    "id": "37771328028923",
    "src": "https://boltagency.ca/content/images/2020/03/placeholder-images-product-1_large.png"
   }
  ],
  "options": [
   {
    "id": "9987733979387",
    "name": "Title",
    "position": 1,
    "values": [
     "Default Title"
    ]
   }
  ],
  "price": "120.99",
  "title": "Most Expensive Product",
  "variants": [
   {
    "id": "43276074680571",
    "price": "120.99",
    "title": "Default Title"
   }
  ]
 }

 
export const PRODUCT_CHEAPEST_SELECT =  {
  "id": "77700069445",
  "originalDescription": "<p>Lorem Ipsumis simply dummy text. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>",
  "description": "{productDescription}",
  "description_quill": "{\"ops\":[{\"insert\":\"{productDescription}\\n\"}]}",
  "handle": "cheapest",
  "image": "https://boltagency.ca/content/images/2020/03/placeholder-images-product-1_large.png",
  "images": [
   {
    "id": "37771328028923",
    "src": "https://boltagency.ca/content/images/2020/03/placeholder-images-product-1_large.png"
   }
  ],
  "options": [
   {
    "id": "9987733979387",
    "name": "Title",
    "position": 1,
    "values": [
     "Default Title"
    ]
   }
  ],
  "price": "9.99",
  "title": "Cheapest Product",
  "variants": [
   {
    "id": "43276074680571",
    "price": "9.99",
    "title": "Default Title"
   }
  ]
 }


 export const NEW_AUTO_FUNNEL = ({primary_discount, secondary_discount} ) => {
  return {
      funnelType: "auto_funnel", 
      offer_testing: false,
      offer_testStatus: null, // running, "hold", 
      offer: defaultOffer({product: PRODUCT_EXPENSIVE_SELECT, productType: "most_expensive", discount_value: secondary_discount}),
      offer_B: defaultOffer(),

      upsell_testing: false,
      upsell_testStatus: null, // running, "hold", 
      upsell: defaultOffer({product: PRODUCT_AUTO_SELECT, productType: "auto_upsell", discount_value: primary_discount}),
      upsell_B: defaultOffer(),

      downsell_testing: false,
      downsell_testStatus: null, // running, "hold", 
      downsell:  defaultOffer({product: PRODUCT_AUTO_SELECT, productType: "auto_upsell", discount_value: primary_discount}),
      downsell_B: defaultOffer(),
      
      advandced_goals: {
        isActive: false,
        cart_value: {
          isActive: true,
          target: 0,
          relatively: "more_than"
        },
        quantity: {
          isActive: true,
          target: 0,
          relatively: "more_than"
        }
      }
  };
};
 
export const OFFERS = ["offer", "offer_B", "upsell_B", "downsell_B", "downsell", "upsell"] 


export const CHECKER_POSITION = [
  { value: "right", label: "Right" },
  { value: "left", label: "Left" },
]
export const OFFER_POSITION = [
  { value: "above", label: "Above checkout" },
  { value: "below", label: "Below checkout" },
]
export const CHECKER_TYPE = [
  { value: "ticker", label: "Ticker" },
  { value: "checker", label: "Checkbox" },
]


export const VARIANTS = [
  {
      "price": "1.00",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "1.00"
  },
  {
      "price": "2.01",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "2.01"
  },
  {
      "price": "3.02",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "3.02"
  },
  {
      "price": "4.03",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "4.03"
  },
  {
      "price": "5.04",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "5.04"
  },
  {
      "price": "6.05",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "6.05"
  },
  {
      "price": "7.06",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "7.06"
  },
  {
      "price": "8.07",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "8.07"
  },
  {
      "price": "9.08",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "9.08"
  },
  {
      "price": "10.09",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "10.09"
  },
  {
      "price": "11.10",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "11.10"
  },
  {
      "price": "12.11",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "12.11"
  },
  {
      "price": "13.12",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "13.12"
  },
  {
      "price": "14.13",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "14.13"
  },
  {
      "price": "15.14",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "15.14"
  },
  {
      "price": "16.15",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "16.15"
  },
  {
      "price": "17.16",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "17.16"
  },
  {
      "price": "18.17",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "18.17"
  },
  {
      "price": "19.18",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "19.18"
  },
  {
      "price": "20.19",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "20.19"
  },
  {
      "price": "21.20",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "21.20"
  },
  {
      "price": "22.21",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "22.21"
  },
  {
      "price": "23.22",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "23.22"
  },
  {
      "price": "24.23",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "24.23"
  },
  {
      "price": "25.24",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "25.24"
  },
  {
      "price": "26.25",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "26.25"
  },
  {
      "price": "27.26",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "27.26"
  },
  {
      "price": "28.27",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "28.27"
  },
  {
      "price": "29.28",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "29.28"
  },
  {
      "price": "30.29",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "30.29"
  },
  {
      "price": "31.30",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "31.30"
  },
  {
      "price": "32.31",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "32.31"
  },
  {
      "price": "33.32",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "33.32"
  },
  {
      "price": "34.33",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "34.33"
  },
  {
      "price": "35.34",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "35.34"
  },
  {
      "price": "36.35",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "36.35"
  },
  {
      "price": "37.36",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "37.36"
  },
  {
      "price": "38.37",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "38.37"
  },
  {
      "price": "39.38",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "39.38"
  },
  {
      "price": "40.39",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "40.39"
  },
  {
      "price": "41.40",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "41.40"
  },
  {
      "price": "42.41",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "42.41"
  },
  {
      "price": "43.42",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "43.42"
  },
  {
      "price": "44.43",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "44.43"
  },
  {
      "price": "45.44",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "45.44"
  },
  {
      "price": "46.45",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "46.45"
  },
  {
      "price": "47.46",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "47.46"
  },
  {
      "price": "48.47",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "48.47"
  },
  {
      "price": "49.48",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "49.48"
  },
  {
      "price": "50.49",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "50.49"
  },
  {
      "price": "51.50",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "51.50"
  },
  {
      "price": "52.51",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "52.51"
  },
  {
      "price": "53.52",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "53.52"
  },
  {
      "price": "54.53",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "54.53"
  },
  {
      "price": "55.54",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "55.54"
  },
  {
      "price": "56.55",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "56.55"
  },
  {
      "price": "57.56",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "57.56"
  },
  {
      "price": "58.57",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "58.57"
  },
  {
      "price": "59.58",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "59.58"
  },
  {
      "price": "60.59",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "60.59"
  },
  {
      "price": "61.60",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "61.60"
  },
  {
      "price": "62.61",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "62.61"
  },
  {
      "price": "63.62",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "63.62"
  },
  {
      "price": "64.63",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "64.63"
  },
  {
      "price": "65.64",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "65.64"
  },
  {
      "price": "66.65",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "66.65"
  },
  {
      "price": "67.66",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "67.66"
  },
  {
      "price": "68.67",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "68.67"
  },
  {
      "price": "69.68",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "69.68"
  },
  {
      "price": "70.69",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "70.69"
  },
  {
      "price": "71.70",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "71.70"
  },
  {
      "price": "72.71",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "72.71"
  },
  {
      "price": "73.72",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "73.72"
  },
  {
      "price": "74.73",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "74.73"
  },
  {
      "price": "75.74",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "75.74"
  },
  {
      "price": "76.75",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "76.75"
  },
  {
      "price": "77.76",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "77.76"
  },
  {
      "price": "78.77",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "78.77"
  },
  {
      "price": "79.78",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "79.78"
  },
  {
      "price": "80.79",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "80.79"
  },
  {
      "price": "81.80",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "81.80"
  },
  {
      "price": "82.81",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "82.81"
  },
  {
      "price": "83.82",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "83.82"
  },
  {
      "price": "84.83",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "84.83"
  },
  {
      "price": "85.84",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "85.84"
  },
  {
      "price": "86.85",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "86.85"
  },
  {
      "price": "87.86",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "87.86"
  },
  {
      "price": "88.87",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "88.87"
  },
  {
      "price": "89.88",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "89.88"
  },
  {
      "price": "90.89",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "90.89"
  },
  {
      "price": "91.90",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "91.90"
  },
  {
      "price": "92.91",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "92.91"
  },
  {
      "price": "93.92",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "93.92"
  },
  {
      "price": "94.93",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "94.93"
  },
  {
      "price": "95.94",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "95.94"
  },
  {
      "price": "96.95",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "96.95"
  },
  {
      "price": "97.96",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "97.96"
  },
  {
      "price": "98.97",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "98.97"
  },
  {
      "price": "99.98",
      "inventory_quantity": 1,
      "inventory_policy": "continue",
      "option1": "99.98"
  }
]